export default __webpack_public_path__ + "static/media/dg-title-en.d4bcab47.webp";